// extracted by mini-css-extract-plugin
export var container = "Agreements-module--container--2UB-q";
export var infoContainer = "Agreements-module--infoContainer--3SMfw";
export var row = "Agreements-module--row--bKvUF";
export var textContainer = "Agreements-module--textContainer--36Tl3";
export var warning = "Agreements-module--warning--1xHcu";
export var agreement = "Agreements-module--agreement--2FXeT";
export var checkbox = "Agreements-module--checkbox--2piuN";
export var checkedBox = "Agreements-module--checkedBox--3hDQ5";
export var preRegisterButton = "Agreements-module--preRegisterButton--3KwHN";